<template>
    <div>
        <v-card :loader="loader">
            <div slot="header">
                <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
                    <div>
                        <v-text nowrap type="title">
                            Лицензионное соглашение
                        </v-text>
                    </div>
                    <div>
                        <v-text type="subheadling">
                            Используя сервис, вы соглашаетесь с
                            <v-text nowrap>
                                <v-link size="subheadling" to="https://exbico.ru/oferta_und" target="_blank">
                                    лицензионным соглашением
                                </v-link>
                            </v-text>
                        </v-text>
                    </div>
                </div>
            </div>
        </v-card>
    </div>
</template>

<script>
import {
    validate,
    isFilesLessThan,
    isFilesValidExtension,
} from '../../../services/validator';

const maxFileSize = 7;
const extensions = [
    'jpg', 'jpeg', 'png', 'pdf', 'tiff', 'tif',
];

const fileRules = [
    (files) => isFilesValidExtension(files, extensions),
    (files) => isFilesLessThan(files, maxFileSize),
];

const rules = {
    contract: fileRules,
    ogrn: fileRules,
};

export default {
    name: 'contract-paper',
    props: {
        onUpload: Function,
        contractFiles: Array,
        ogrnFiles: Array,
        contractLink: String,
        isFilled: Boolean,
        loader: Boolean,
    },
    data() {
        return {
            contract: false,
            ogrn: false,
            errors: {},
        }
    },
    methods: {
        validateFiles(values) {
            const errors = validate(values, rules);
            return errors;
        },
        handleUpload(field, files) {
            this[field] = true;
            this.onUpload(field, files)
                .then((res) => {
                    this[field] = false;
                })
                .catch((res) => {
                    this.errors = {
                        ...this.errors,
                        [field]: res.message
                    };
                    this[field] = false;
                });
        },
        handleRemove(field, e) {
            this.$emit('remove', {
                field,
                ...e,
            });
        },
        downloadContract() {
            window.location = '/api/v1/file/contract';
        }
    }
}
</script>



// WEBPACK FOOTER //
// ContractPaper.vue?1fd425d2